<template>
  <div class="modal upload">
    <form class="form-group">
      <files-icon width="50" height="65" fillColor="#81869E"></files-icon>
      <h2
        v-if="determineDragAndDropCapable"
        v-html="$t('dashboard-modal-drag-and-drop')"
      ></h2>
      <div class="form-group flex">
        <button class="default" @click="closeModalclearExchangeDraft">
          <close-icon width="15px" height="15px"></close-icon>
          {{ $t("dashboard-modal-cancel") }}
        </button>
        <label class="upload-file-wrapper primary">
          <folder-open width="16" height="15"></folder-open>
          {{ $t("dashboard-modal-choose-files") }}
          <input
            type="file"
            id="files"
            ref="files"
            multiple
            v-on:change="handleFilesUpload()"
          />
        </label>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CloseIcon from "@/components/icons/CloseIcon";
import FolderOpen from "@/components/icons/FolderOpenIcon";
import FilesIcon from "@/components/icons/FilesIcon";

export default {
  name: "Upload",
  props: {
    determineDragAndDropCapable: {
      required: true
    }
  },
  components: {
    CloseIcon,
    FolderOpen,
    FilesIcon
  },
  computed: {
    ...mapState("exchange", [
      "choosenFiles",
      "incompleteExchanges",
      "exchangeId"
    ])
  },
  methods: {
    ...mapActions("common", ["setLoading", "showModal"]),
    ...mapActions("exchange", [
      "setChoosenFiles",
      "updateExchangeFiles",
      "deleteOutgoingExchange"
    ]),
    handleFilesUpload() {
      this.$emit("handleFilesUpload", this.$refs.files.files);
    },
    closeUploadModal() {
      this.$emit("closeUploadModal");
    },
    closeModalclearExchangeDraft() {
      this.$emit("closeModalclearExchangeDraft");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/styles/variables";

.modal {
  display: flex;
  pointer-events: none;
  &.upload {
    align-items: center;
    flex-direction: column;
    padding: 60px 0;
    max-width: 500px;
    justify-content: center;
    background: $light-gray;
    height: 50%;
    max-height: 400px;
    border: 2px dashed $placeholder-color;
    h2 {
      color: $placeholder-color;
    }
  }
}
</style>
